import { render, staticRenderFns } from "./SettingsInternalPlugin.vue?vue&type=template&id=37f9001f&scoped=true&"
import script from "./SettingsInternalPlugin.vue?vue&type=script&lang=js&"
export * from "./SettingsInternalPlugin.vue?vue&type=script&lang=js&"
import style0 from "./SettingsInternalPlugin.vue?vue&type=style&index=0&id=37f9001f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f9001f",
  null
  
)

export default component.exports